<template>
  <v-container class="booking-preview p-0" v-if="bookingRecord" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="facilityType.name.toUpperCase()"
                         :is-snap-content="true">
      <v-row class="booking-preview-content-row mb-3 py-3">
        <v-col>
          <v-form v-model="isFormValid" class="booking-preview-form text-left">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-row class="booking-preview-form-title">
                    <v-col>{{ $t('booking_preview.booking_preview') }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field readonly
                                    hide-details
                                    :label="$t('booking.reserved_at')"
                                    :value="$parseDate(bookingRecord.create_at, 'yyyy-MM-dd | HH:mm')"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-input hide-details>
                        <v-container fluid class="pa-0 flex-column">
                          <legend class="v-label theme--light">{{ $t('booking.facility') }}</legend>
                          <v-row v-for="booking in sortedBookings"
                                 :key="booking.id">
                            <v-col>
                              <b>{{ booking.item.name }}</b>
                            </v-col>
                            <v-col class="text-right">
                              <small class="form-text text-muted">{{ $parseDate(booking.start_time) + ' - ' + $parseDate(booking.end_time, 'HH:mm') }}</small>
                            </v-col>
                            <v-col cols="12"
                                   v-if="booking.additional_items.length > 0">
                              <ul style="list-style-type: none;">
                                <li v-for="additional_item in booking.additional_items">
                                  {{ additional_item.type.name }} x {{ additional_item.count }}
                                </li>
                              </ul>
                            </v-col>
                            <v-col cols="12">
                              <v-select :label="$t('booking.coupons')"
                                        :items="couponOptions(booking)"
                                        v-model="selectedCoupons[booking.id]"
                                        :rules="couponRules(booking)"
                                        dense></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field v-if="!discountCodeRecord"
                                    outlined
                                    hide-details="auto"
                                    :label="$t('booking.discount_code')"
                                    v-model="discountCode"
                                    :error-count="!!discountCodeErrorMessage ? 1 : 0"
                                    :error-messages="discountCodeErrorMessage"
                                    append-icon="mdi-check"
                                    @click:append="applyDiscountCode"
                                    @keydown.enter="applyDiscountCode"></v-text-field>
                      <v-text-field v-if="discountCodeRecord"
                                    readonly
                                    hide-details="auto"
                                    :label="$t('booking.discount_code')"
                                    :value="discountCode"
                                    :error-count="!!discountCodeErrorMessage ? 2 : 0"
                                    :error-messages="discountCodeErrorMessage ? [discountCodeDescriptions, discountCodeErrorMessage] : []"
                                    append-outer-icon="mdi-close"
                                    @click:append-outer="clearDiscountCode"
                                    :hint="discountCodeDescriptions"
                                    persistent-hint>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field readonly
                                    hide-details
                                    :label="$t('booking.fee')"
                                    :value="`HKD ${price}`"></v-text-field>
                    </v-col>
                  </v-row>
                  <!--                  <v-row>-->
                  <!--                    <v-col>-->
                  <!--                      <v-checkbox light-->
                  <!--                                  v-model="needBbqOption"-->
                  <!--                                  v-if="isAccBbq"-->
                  <!--                                  :label="$t('booking.need_bbq_option')">-->
                  <!--                      </v-checkbox>-->
                  <!--                    </v-col>-->
                  <!--                  </v-row>-->
                  <v-row>
                    <v-col>
                      <v-checkbox light
                                  v-model="accepted"
                                  @click.stop="showTnc"
                                  validate-on-blur>
                        <template v-slot:label>
                          <div @click.stop="showTnc">{{ $t('booking_preview.accept_tnc1') }} {{ $t('booking_preview.accept_tnc2') }}</div>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field :label="$t('booking.second_contact_number')"
                                    v-model="secondContactNumber"
                                    :rules="secondContactNumberRules"
                                    validate-on-blur></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="booking-preview-form-title">
                    <b-col>{{ $t('booking_preview.time_left') }} {{ timeLeft }}</b-col>
                  </v-row>
                  <v-row class="preview-warning-label">
                    <v-col>{{ $t('booking_preview.preview_warning') }}</v-col>
                  </v-row>
                  <v-row class="booking-preview-form-title">
                    <v-col class="pb-0">{{ $t('booking.payment_method') }}</v-col>
                  </v-row>
                  <v-row v-if="price > 0">
                    <v-col class="pt-0">
                      <v-container>
                        <!--                        <v-row class="mb-4">-->
                        <!--                          <v-col cols="12"-->
                        <!--                                 :class="['pa-4', 'text-center', 'booking-preview-payment-method',{'enabled': canPayByPoint}, {'active': paymentMethod === 'point'}]"-->
                        <!--                                 @click="canPayByPoint ? paymentMethod = 'point' : null">-->
                        <!--                            {{ $t('booking.pay_by_point') }} {{ `(${$t('my_account.point_balance')}: ${pointBalance})` }}-->
                        <!--                          </v-col>-->
                        <!--                        </v-row>-->
                        <v-row class="mb-4">
                          <v-col cols="12"
                                 :class="['booking-preview-payment-method', 'enabled', {'active': paymentMethod === 'cyber_source'}]"
                                 @click="paymentMethod = 'cyber_source'">
                            <v-img :src="require('@/assets/logo-credit-cards.png')"></v-img>
                          </v-col>
                          <!--                          <v-col cols="1"></v-col>-->
                          <!--                          <v-col cols="4"-->
                          <!--                                 :class="['booking-preview-payment-method', 'enabled', {'active': paymentMethod === 'union_pay'}]"-->
                          <!--                                 @click="paymentMethod = 'union_pay'">-->
                          <!--                            <v-img :src="require('../../../assets/logo-union-pay.png')"></v-img>-->
                          <!--                          </v-col>-->
                        </v-row>
                        <!--                        <v-row>-->
                        <!--                          <v-col cols="12"-->
                        <!--                                 :class="['pa-4', 'text-center', 'booking-preview-payment-method', 'pay-by-octopus']">-->
                        <!--                            <div class="pay-by-octopus-wrapper">-->
                        <!--                              <v-img max-height="50" contain :src="require('../../../assets/octopus.png')"></v-img>-->
                        <!--                              <span class="col-9 pay-by-octopus-description">{{ $t('booking.pay_with_octopus') }}</span>-->
                        <!--                            </div>-->
                        <!--                          </v-col>-->
                        <!--                        </v-row>-->
                      </v-container>
                    </v-col>
                  </v-row>
                  <v-row v-if="price > 0 && paymentMethod === 'cyber_source'">
                    <v-col>
                      <v-radio-group v-model="selectedPaymentToken">
                        <v-radio v-for="paymentToken in paymentTokens"
                                 :key="paymentToken.id"
                                 :value="paymentToken.id">
                          <template #label>
                            <v-img :src="cardTypeLogo[paymentToken.card_type]"
                                   :max-width="40"
                                   :max-height="30"
                                   class="mr-4"></v-img>
                            {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                          </template>
                        </v-radio>
                        <v-radio :value="false">
                          <template #label>
                            <v-icon class="mr-4">fas fa-plus-square</v-icon>
                            {{ $t('booking_preview.add_payment_token') }}
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row class="mb-4"
                         v-if="price <= 0">
                    <v-col cols="12"
                           :class="['pa-8', 'text-center', 'booking-preview-payment-method', 'enabled', 'active']">
                      {{ $t('booking.no_need_to_pay') }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>

      <v-row class="booking-preview-steps  py-2 px-2 py-md-6 px-md-6">
        <v-col cols="12" v-if="$vuetify.breakpoint.width > 600">
          <v-avatar color="primary" size="36">
            <span class="text-white">1</span>
          </v-avatar>
          <span>{{ $t('booking.step_1') }}</span>
          <v-icon>mdi-arrow-right</v-icon>
          <v-avatar color="primary" size="36">
            <span class="text-white">2</span>
          </v-avatar>
          <span>{{ $t('booking.step_2') }}</span>
          <v-icon>mdi-arrow-right</v-icon>
          <v-avatar color="grey" size="36">
            <span class="text-white">3</span>
          </v-avatar>
          <span class="text-muted">{{ $t('booking.step_3') }}</span>
          <!--                    <v-btn color="primary" rounded large-->
          <!--                           :disabled="!selectedTimeSlots.length"-->
          <!--                           @click="reserveTimeSlots"-->
          <!--                           class="ml-9">-->
          <!--                        <v-icon>mdi-arrow-right-circle-outline</v-icon>-->
          <!--                        {{$t('booking.next_step')}}-->
          <!--                    </v-btn>-->
        </v-col>
        <v-col cols="6" v-if="$vuetify.breakpoint.width <= 600" class="text-left font-size-25">
          <v-row>
            <v-col>
              <v-avatar color="primary" size="36">
                <span class="text-white">1</span>
              </v-avatar>
              <span>{{ $t('booking.step_1') }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-avatar color="primary" size="36">
                <span class="text-white">2</span>
              </v-avatar>
              <span>{{ $t('booking.step_2') }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-avatar color="grey" size="36">
                <span class="text-white">3</span>
              </v-avatar>
              <span class="text-muted">{{ $t('booking.step_3') }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col :class="$vuetify.breakpoint.width <= 600?'text-center':'text-right'" :cols="$vuetify.breakpoint.width <= 600?6:12">
          <v-btn color="primary" rounded :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2"
                 :disabled="!isFormValid || !accepted || (!paymentMethod && price > 0)"
                 @click="next">
            <v-icon>mdi-arrow-right-circle-outline</v-icon>
            <span class="font-size-35">{{ $t('booking.next_step') }}</span>
          </v-btn>
          <v-row :class="['align-end', {'flex-column': $vuetify.breakpoint.width <= 600}]"
                 v-if="paymentMethod === 'cyber_source'">
            <v-spacer></v-spacer>
            <v-img max-width="100px" height="50px" contain :src="require('../../../assets/visa-secure.jpg')"></v-img>
            <v-img max-width="100px" height="50px" contain :src="require('../../../assets/mastercard-securecode.png')"></v-img>
            <v-img max-width="100px" height="50px" contain :src="require('../../../assets/jcb-secure.gif')"></v-img>
          </v-row>
        </v-col>
      </v-row>

    </HkiaraceBannerFrame>
    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light>
        <v-card-title class="tnc-title title-font">{{ tnc.title + $t('and') + tnc.privacy_title }}</v-card-title>

        <v-card-text @scroll="onScroll" v-html="tnc.content + tnc.privacy_content" class="text-left"></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>
          <span v-if="!tncScrolledToBottom">{{ $t('booking.tnc_scroll_to_bottom') }}</span>
          <v-spacer></v-spacer>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 @click="setAcceptTnc(true)">
            {{ $t('register.agree') }}
          </v-btn>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="setAcceptTnc(false)">
            {{ $t('register.disagree') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons'
import {DateTime} from 'luxon'
import _ from 'lodash'
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {computed, onMounted, onUnmounted, ref, watch} from '@vue/composition-api';
import {BOOKING_RECORD_STATUS} from "@/constants";

library.add(faExclamationCircle);

export default {
  name: 'BookingPreview',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {


    // Count Down
    const countDownInterval = ref(null);
    const timeLeft = ref('10:00');

    // Record
    const bookingRecordId = ref(root.$route.params.bookingRecordId);
    const bookingRecord = ref(null);
    const sortedBookings = computed(() => {
      return _.sortBy(bookingRecord.value.bookings, 'start_time');
    })
    const calculateTimeLeft = function () {
      let valid_until = null;
      if (bookingRecord.value.status === BOOKING_RECORD_STATUS.PENDING) {
        valid_until = DateTime.fromISO(bookingRecord.value.create_at).plus({minutes: 10});
      } else if (bookingRecord.value.status === BOOKING_RECORD_STATUS.PAYING) {
        valid_until = DateTime.fromISO(bookingRecord.value.payment_inited_at).plus({minutes: 30});
      }

      if (valid_until === null || DateTime.local() > valid_until) {
        clearInterval(countDownInterval.value)
        root.$showAlertMessage(
          root.$t('booking_preview.order_expired_msg'),
          () => {
            root.$router.replace({name: 'my-account', query: {t: 2}});
          }
        )
      }

      let diff = valid_until.diff(DateTime.local(), ['minutes', 'seconds']);

      timeLeft.value = Math.floor(diff.minutes).toString().padStart(2, '0') + ":" + Math.floor(diff.seconds).toString().padStart(2, '0');
    }
    const getBookingRecord = function () {
      root.$callAPI('room/booking/', {booking_record_id: bookingRecordId.value}, function (response) {
        bookingRecord.value = response.body.booking_record;

        getCoupons();
        getAppliedDiscountCode();

        countDownInterval.value = setInterval(calculateTimeLeft, 1000);
      });
    }

    // Form
    const isFormValid = ref(false);
    const facilityItem = computed(() => {
      return bookingRecord.value.bookings[0].item;
    })
    const facilityType = computed(() => {
      return facilityItem.value ? facilityItem.value.type : null;
    })
    const facilityItemLabel = computed(() => {
      return bookingRecord.value.bookings.map((b) => b.item.name).join(', ');
    });
    const bookingTime = computed(() => {
      let startTime = DateTime.fromISO(bookingRecord.value.bookings[0].start_time);
      let endTime = DateTime.fromISO(bookingRecord.value.bookings[0].end_time);

      bookingRecord.value.bookings.forEach((b) => {
        let bookingStartTime = DateTime.fromISO(b.start_time);
        let bookingEndTime = DateTime.fromISO(b.end_time);

        if (bookingStartTime < startTime) {
          startTime = bookingStartTime;
        }

        if (bookingEndTime > endTime) {
          endTime = bookingEndTime;
        }
      });

      return startTime.toFormat('HH:mm') + ' - ' + endTime.toFormat('HH:mm');
    })

    const discountCode = ref(null);
    const discountCodeError = ref(null);
    const discountCodeRecord = ref(null);
    const discountCodeErrorMessage = computed(() => {
      if (discountCodeError.value) return discountCodeError.value;

      if (discountCodeRecord.value && bookingRecord.value) {
        const discountCode = discountCodeRecord.value.discount_code;
        // Discount Code Type
        if (discountCode.type !== 'FACILITY') return root.$t('error_messages.discount_code_not_applicable');

        // Item Type
        if (discountCode.item_type) {
          const applicableBookings = _.filter(bookingRecord.value.bookings, (b) => {
            return b.item.type.id === discountCode.item_type.id;
          });
          if (applicableBookings.length === 0) {
            console.log('no matching booking item_type')
            return root.$t('error_messages.discount_code_not_applicable');
          }
          const applicableAmount = _.sumBy(applicableBookings, (b) => {
            return b.fee - (selectedCoupons[b.id] ? selectedCoupons[b.id].value : 0);
          });

          if (applicableAmount < discountCode.minimum_amount) return root.$t('error_messages.discount_code_minimum_not_met')
        } else {
          console.log('no item_type')
          return root.$t('error_messages.discount_code_not_applicable');
        }
      }

      return null;
    })
    const discountCodeDescriptions = computed(() => {
      if (discountCodeRecord.value) {
        return root.$getDiscountCodeDescription(discountCodeRecord.value.discount_code);
      }
    })
    const discountCodeDiscount = computed(() => {
      if (discountCodeRecord.value && !discountCodeErrorMessage.value) {
        const discountCode = discountCodeRecord.value.discount_code;

        if (discountCode.discount_value > 0) return discountCode.discount_value;

        const applicableBookings = _.filter(bookingRecord.value.bookings, (b) => {
          return b.item.type.id === discountCode.item_type.id;
        });
        const applicableAmount = _.sumBy(applicableBookings, (b) => {
          return b.fee - (selectedCoupons[b.id] ? selectedCoupons[b.id].value : 0);
        });

        return Math.floor(applicableAmount * discountCode.discount_percentage / 100);
      }

      return 0;
    })
    const getAppliedDiscountCode = function () {
      root.$callAPI('aafb/applied_discount_code/', {
        booking_record_id: bookingRecordId.value,
      }, (response) => {
        if (response.body.record) {
          discountCodeRecord.value = response.body.record;
          discountCode.value = response.body.record.discount_code.code;
        } else {
          discountCodeRecord.value = null;
          discountCode.value = null;
        }
      })
    }
    const applyDiscountCode = function () {
      if (discountCode.value) {
        discountCodeError.value = null;
        root.$callAPI('aafb/shopping_cart/apply_code/', {
          'code': discountCode.value,
        }, (response) => {
          if (response.body.record) {
            discountCodeRecord.value = response.body.record;
            discountCode.value = response.body.record.discount_code.code;
          } else {
            discountCodeRecord.value = null;
            discountCode.value = null;
          }
        }, (response) => {
          discountCodeError.value = response.body.msg || 'invalid_discount_code';
          console.log(response);
        })
      }
    }
    const clearDiscountCode = function () {
      if (discountCodeRecord.value && confirm(root.$t('booking.clear_discount_code'))) {
        discountCodeError.value = null;
        root.$callAPI('aafb/shopping_cart/clear_code/', {}, () => {
          getAppliedDiscountCode()
        }, (response) => {
          console.log(response);
        })
      }
    }
    const price = computed(() => {
      let couponDiscount = 0;

      Object.values(selectedCoupons.value).forEach(c => {
        if (c) couponDiscount += c.amount;
      })

      return bookingRecord.value.fee - couponDiscount - discountCodeDiscount.value;
    })
    const secondContactNumber = ref(root.$store.state.user.mobile);
    const secondContactNumberRules = ref([
      (value) => (/^[0-9]*$/g.test(value) && value.length === 8) || root.$t('booking.invalid_second_contact_number'),
    ])
    const paymentMethod = ref(null);
    const isAccBbq = computed(() => {
      return bookingRecord.value.bookings[0].item.type.is_acc_bbq;
    })
    const needBbqOption = ref(false);

    // Point
    const pointBalance = computed(() => root.$store.state.user.point_balance);
    const canPayByPoint = computed(() => price.value <= pointBalance.value);

    // Payment Token
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }
    watch(() => paymentMethod.value, (newValue) => {
      if (newValue === 'cyber_source') {
        getPaymentTokens();
      }
    })

    // Coupon
    const coupons = ref([]);
    const couponOptions = function (booking) {
      return _.concat(
        [{value: null, text: root.$t('booking.no_coupon')}],
        coupons.value.filter((c) => {
          if (c.gym_pass_type) return false;

          let couponTypeId = c.item_type ? c.item_type.id : c.from_booking.item.type.id;

          return couponTypeId === booking.item.type.id;
        }).map(function (c) {
          let itemType = c.item_type ? c.item_type : c.from_booking.item.type;

          return {
            value: c,
            text: `HKD ${c.amount} - ${itemType.name} - ${c.id.substr(0, 6)}`,
          }
        }))
    };
    const couponRules = function (booking) {
      return [
        value => {
          if (!value) return null

          return !Object.keys(selectedCoupons.value).some((coupon_booking_id) => {
            if (!selectedCoupons.value[coupon_booking_id]) return false;

            return booking.id !== coupon_booking_id && selectedCoupons.value[coupon_booking_id].id === value.id;
          }) || root.$t('booking.duplicate_coupon');
        },
      ];
    }
    const selectedCoupons = ref({});
    const getCoupons = function () {
      root.$callAPI('aafb/coupon/', {max_amount: bookingRecord.value.fee, show_only_valid: true}, function (response) {
        coupons.value = response.body.coupons;
      })
    }

    // TNC
    const tnc = ref('');
    const tncDialogShown = ref(false);
    const tncScrolledToBottom = ref(false);
    const accepted = ref(false);
    const getTNC = function () {
      root.$callAPI('hkiarace/tnc/', {}, function (response) {
        tnc.value = response.body;
      });
    };
    const showTnc = function (e) {
      e.preventDefault();

      if (!accepted.value) {
        tncDialogShown.value = true;
      } else {
        accepted.value = false;
      }
    };
    const onScroll = function ({target: {scrollTop, clientHeight, scrollHeight}}) {
      if (scrollTop + clientHeight >= (scrollHeight - 10)) {
        tncScrolledToBottom.value = true
      }
    }
    const setAcceptTnc = function (accept) {
      tncDialogShown.value = false;
      accepted.value = accept;
    }


    // const cancel = function () {
    //   if (confirm('Cancel Booking?')) {
    //     root.$callAPI('aafb/expire_booking/', {booking_record_id: bookingRecordId.value}, function (response) {
    //       // this.$router.replace({name: 'facility-reserve', itemTypeId: this.bookingRecord.bookings[0].item.type.id});
    //       this.$router.back();
    //     });
    //   }
    // };
    const next = function () {
      if (confirm(root.$t('booking_preview.redirect_warning'))) {
        let coupons = {};
        Object.keys(selectedCoupons.value).forEach((k) => {
          if (selectedCoupons.value[k]) {
            coupons[k] = selectedCoupons.value[k].id;
          }
        })

        root.$callAPI('aafb/init_payment/', {
          payment_method: price.value > 0 ? paymentMethod.value : 'NO_NEED_TO_PAY',
          payment_token_id: selectedPaymentToken.value,
          coupons: JSON.stringify(coupons),
          booking_record_id: bookingRecordId.value,
          second_contact_number: secondContactNumber.value,
          need_bbq_option: needBbqOption.value,
        }, function (response) {
          if (response.body.no_need_to_pay) {
            root.$storeDispatch('getShoppingCart');
            root.$router.replace({name: 'booking-confirm', params: {bookingRecordId: response.body.booking_record_id}});
          } else {
            postForm(response.body.url, response.body.params)
          }
        });
      }
    }
    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }

    onMounted(() => {
      getTNC();
      getBookingRecord();
    })

    onUnmounted(() => {
      clearInterval(countDownInterval.value);
    })

    return {
      bookingRecordId,
      bookingRecord,
      sortedBookings,

      countDownInterval,
      timeLeft,

      isFormValid,
      facilityItem,
      facilityType,
      facilityItemLabel,
      bookingTime,
      discountCode,
      discountCodeRecord,
      discountCodeErrorMessage,
      discountCodeDescriptions,
      discountCodeDiscount,
      applyDiscountCode,
      clearDiscountCode,
      price,
      secondContactNumber,
      secondContactNumberRules,
      paymentMethod,
      isAccBbq,
      needBbqOption,

      pointBalance,
      canPayByPoint,

      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      coupons,
      couponOptions,
      couponRules,
      selectedCoupons,

      tnc,
      tncDialogShown,
      tncScrolledToBottom,
      accepted,
      showTnc,
      onScroll,
      setAcceptTnc,

      next,
    }
  },
}
</script>

<style lang="less">
.booking-preview {
  .booking-preview-banner {
    .booking-preview-banner-label {
      position: absolute;
      left: 50%;
      top: 50%;
      color: white;
      font-size: 3rem;
      text-shadow: 2px 2px rgba(0, 0, 0, 0.25);
      transform: translate(-50%, -50%);
    }
  }

  .booking-preview-content-row {
    background-color: white;

    .booking-preview-form {
      max-width: 1024px;
      margin: auto;

      .v-label {
        color: #8E765B;
      }

      .v-input--is-readonly > .v-input__control > .v-input__slot:before {
        display: none;
      }

      .v-input--is-readonly > .v-input__control > .v-input__slot:after {
        display: none;
      }

      .booking-preview-form-title {
        font-size: 1.5rem;
      }

      .preview-warning-label {
        font-size: .8rem;
      }

      .booking-preview-payment-method {
        border: 2px solid rgba(0, 0, 0, 0.2);

        &.enabled {
          cursor: pointer;

          &:hover, &.active {
            border-color: #8E765B;
          }
        }

        &.pay-by-octopus {
          background: #F3F4F8;

          .pay-by-octopus-wrapper {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .v-image {
              -webkit-box-flex: 0;
              -ms-flex: 0 0 25%;
              flex: 0 0 25%;
              max-width: 25%;
            }


            .pay-by-octopus-description {
              color: #B3B4B8;
              font-size: 90%;
              text-align: left;
            }
          }
        }
      }
    }
  }

  .booking-preview-steps {
    .v-avatar {
      margin-right: 12px;
    }

    .mdi-arrow-right {
      margin-left: 24px;
      margin-right: 12px;
    }
  }

  .booking-preview-content {
    background-color: #efefef;

    .booking-preview-content-wrapper {
      /*transform: translateY(-120px);*/
      background-color: #efefef;

      .datepicker-calendar {
        width: 100%;
        border: none;
        margin: auto;
      }


    }
  }
}
</style>
